"use client";

import Link from "next/link";

/** Shelf Life Wisdom — listing hero (navy band, editorial tokens). */
export function NewBlogLandingHero({ guideCount }: { guideCount: number }) {
  return (
    <section className="ed-blog-landing-hero-slw">
      <div className="ed-blog-landing-hero-slw__inner">
        <div className="ed-blog-landing-hero-slw__grid">
          <div className="ed-blog-landing-hero-slw__visual" aria-hidden />
          <div className="ed-blog-landing-hero-slw__copy">
            <p className="ed-blog-landing-hero-slw__eyebrow">ExpiryDesk publication</p>
            <h1 className="ed-blog-landing-hero-slw__title">Shelf Life Wisdom</h1>
            <p className="ed-blog-landing-hero-slw__tagline">
              Know your <span className="ed-blog-tagline-shelf">shelf</span>.
            </p>
            <p className="ed-blog-landing-hero-slw__desc">
              Calm, practical guidance on expiry control, stock movement, and shelf confidence for pharmacy and retail teams
              in South Africa — written to be read on a phone between deliveries.
            </p>
            <div className="ed-blog-landing-hero-slw__actions">
              <Link href="/blog#more-articles" className="ed-blog-landing-hero-slw__btn ed-blog-landing-hero-slw__btn--primary">
                Browse articles
              </Link>
              <Link href="/blog/newsletter" className="ed-blog-landing-hero-slw__btn ed-blog-landing-hero-slw__btn--ghost">
                Weekly digest
              </Link>
            </div>
          </div>
        </div>
        <div className="ed-blog-landing-hero-slw__stats">
          {[
            { value: `${guideCount}+`, label: "Guides" },
            { value: "ZA", label: "Retail & pharmacy focus" },
            { value: "Clear", label: "Action-first writing" },
            { value: "Shelf", label: "Ops, not slides" },
          ].map((stat, i) => (
            <div key={i} className="ed-blog-landing-hero-slw__stat">
              <div className="ed-blog-landing-hero-slw__stat-value">{stat.value}</div>
              <div className="ed-blog-landing-hero-slw__stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
